module.exports = __webpack_public_path__ + "static/media/Add.0a5133c8.svg";